<template>
  <div class="w-full flex justify-between">
    <template v-if="data.is_fake">
      <div class="w-full py-2 px-3">
        <div
          class="cursor-pointer rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="openOurPlansModal"
        >
          <div
            class="group w-full flex justify-center items-center font-medium text-gray-800"
          >
            <Icon name="LockOpen" class="w-6 mr-4" />

            <p
              class="text-sm font-semibold leading-normal tracking-wider group-focus:text-xl"
            >
              Unlock
            </p>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <!-- <div class="w-full py-2 px-3" v-if="data.analysis">
        <div
          class="cursor-pointer rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="toggleAnalysis"
        >
          <div
            class="w-full flex justify-around items-center font-medium text-gray-800 hover:opacity-50"
          >
            <Icon name="CursorClick" class="w-6" />
            <p class="text-sm font-semibold leading-normal tracking-wider">
              Analysis
            </p>
          </div>
        </div>
      </div> -->
      <!-- <div class="w-full py-2 px-3">
        <div
          class="content mx-auto cursor-pointer rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
          @click="toggleFavoriteState(data)"
        >
          <div
            class="group w-full flex flex-row-reverse justify-between items-center font-medium text-gray-800"
          >
            <div v-if="data.isFavorite">
              <Icon name="Heart" fill="red" stroke="red" class="w-6" />
            </div>
            <div v-else>
              <Icon name="Heart" class="w-6" />
            </div>
            <p
              class="text-sm font-semibold leading-normal tracking-wider group-focus:text-xl"
            >
              Favorite
            </p>
          </div>
        </div>
      </div> -->
    </template>
  </div>
  <!-- <div
    class="w-11/12 flex justify-self-center mt-2 py-2 px-3 h-auto text-gray-800 rounded-md border border-gray-300"
    v-show="showAnalysis"
  >
    <ul class="pl-4 list-disc">
      <li
        v-for="(item, index) in analysisFormat"
        :key="`itemAnalysis${index}`"
        v-show="item"
      >
        <p class="text-sm whitespace-pre-line">{{ item }}</p>
      </li>
    </ul>
  </div> -->
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from "vuex";
import Icon from "@/components/UI/Icon";

export default {
  components: { Icon },
  props: {
    data: Object,
  },
  setup(props) {
    const store = useStore();

    const showAnalysis = ref(false);

    const user = computed(() => store.state.user);
    const role = computed(() => store.state.role);

    const analysisFormat = computed(() => {
      if (props.data.analysis) {
        return props.data.analysis.split("• ");
      }
      return "";
    });

    const toggleAnalysis = () => {
      showAnalysis.value = !showAnalysis.value;
    };

    const toggleFavoriteState = async (ad) => {
      if (["free"].includes(role.value)) {
        openOurPlansModal();
        return true;
      }

      if (ad.isFavorite) {
        await store.dispatch("REMOVE_FAVORITE_ADD", {
          user_id: user.value.id,
          advertisement_id: ad.id,
        });
      } else {
        await store.dispatch("ADD_FAVORITE_AD", {
          user_id: user.value.id,
          advertisement: ad,
        });
      }
    };

    const openOurPlansModal = () => {
      store.commit("SET_OURPLANS_ACTIVE", true);
    };

    return {
      showAnalysis,
      user,
      role,
      analysisFormat,
      toggleFavoriteState,
      toggleAnalysis,
      openOurPlansModal,
    };
  },
};
</script>

<style></style>
